// extracted by mini-css-extract-plugin
export default {"moduleBorderWrap":"styles_moduleBorderWrap__HWBAE","button":"styles_button__Qo4jb","text":"styles_text__wSAZp","icon":"styles_icon__TkG10"};